import React, { useState } from 'react';
import {
  TableCell,
  TableRow,
} from '@material-ui/core';
import {
  lookupService, priceRowType, termLookup, YearDaysForCalculation,
} from '../../../utils/appConstants';
import {
  currencyFormatter, getCityState, getDateAsExcelFormat, getDateAsMonthYear, getDateForPriceRow,
} from '../../../utils/methods';
import TitleSubtitle from '../../DesignSystem/Table/Cells/TitleSubtitle';
import CollapseIcon from '../../../assets/images/collapse-collapsible.svg';

interface PortsRowProps {
  priceRow: priceRowType;
  close?: () => void;
  className?: string;
  hideName?: boolean;
  hideLocation?: boolean;
}

const PriceRow: React.FC<PortsRowProps> = ({
  priceRow, close, className, hideName, hideLocation,
}) => {
  const { row } = priceRow;

  const getTerm = (): { title: string, subtitle: string } => {
    if (row?.term.type === 'contract' || row?.term.type === 'MRC') {
      return {
        title: `$ ${currencyFormatter(row?.term.charge)} / month`,
        subtitle: termLookup[row?.term.type],
      };
    } if (row?.term.type === 'demand') {
      return {
        // eslint-disable-next-line no-unsafe-optional-chaining
        title: `${currencyFormatter(row?.term.charge)}¢ / minute`,
        // eslint-disable-next-line no-unsafe-optional-chaining
        subtitle: `≅ $${currencyFormatter((row?.term.charge / 100) * ((60 * 24 * YearDaysForCalculation) / 12))} / month`,
      };
    }
    return {
      title: `$${currencyFormatter(priceRow.mrc)}`,
      subtitle: termLookup.fee,
    };
  };
  const getDates = (): { title: string, subtitle: string } => {
    if (row?.term.type !== 'fee') {
      return {
        title: `${getDateForPriceRow(row?.dates.start || '')}`,
        subtitle: row?.dates.end ? `${getDateForPriceRow(row?.dates.end || '')}` : '-',
      };
    }
    return {
      title: `${getDateForPriceRow(row?.dates.start || '')}`,
      subtitle: '',
    };
  };
  const formatTotal = (): string => {
    if (priceRow.type === 'expense') {
      return `( $${currencyFormatter(priceRow.mrc)} )`;
    }
    return `$${currencyFormatter(priceRow.mrc)}`;
  };
  const termCell = getTerm();
  const dateCell = getDates();
  const [fontWeight, setFontWeight] = useState<'400' | '700'>('400');
  let termColor = priceRow.type;
  if (priceRow.row?.dates.end) termColor += '-ended';

  return (
    <TableRow
      onMouseOver={() => setFontWeight('700')}
      onMouseLeave={() => setFontWeight('400')}
      className={`${!!className && className} ${(close) && 'pointer'}`}
      onClick={() => close && close()}
    >
      {close ? (
        <TableCell
          onClick={() => close()}
          style={{ fontSize: '30px', cursor: 'pointer', fontWeight: `${fontWeight}` }}
          width="1%"
        >
          -
        </TableCell>
      ) : <TableCell />}
      {(hideName) ? (
        <TitleSubtitle title="" subTitle="" boldTitle width="19%" maxWidth="19vw" align="left" />
      ) : (
        <TitleSubtitle title={row?.description.title || ''} subTitle={row?.description.subtitle} boldTitle width="19%" maxWidth="15vw" align="left" />
      )}
      {(hideLocation) ? (
        <TitleSubtitle title="" subTitle="" boldTitle width="25%" maxWidth="25vw" align="center" />
      ) : (
        <TitleSubtitle title={row?.location.title || ''} subTitle={row?.location.subtitle || ''} boldTitle width="25%" maxWidth="25vw" align="center" />
      )}
      <TitleSubtitle title={row?.targetOrg.title || ''} subTitle={lookupService(row?.targetOrg.subtitle || '')} boldTitle width="15%" maxWidth="15vw" align="center" />
      <TitleSubtitle outlineColor={termColor} title={termCell.title || ''} subTitle={termCell.subtitle || ''} width="15%" maxWidth="15vw" align="center" />
      <TitleSubtitle title={getDateAsExcelFormat(dateCell.title) || ''} subTitle={getDateAsExcelFormat(dateCell.subtitle) || ''} width="10%" maxWidth="10vw" align="center" />
      <TitleSubtitle title={formatTotal()} boldTitle width="10%" maxWidth="10vw" align="right" />
    </TableRow>
  );
};

export default PriceRow;
